const isAnnualAvailable = (plans) => Object.keys(plans).some((plan) => Boolean(plans[plan].P1Y));

export default isAnnualAvailable;
